module.exports = __webpack_public_path__ + "static/img/king-of-contacts.dfd37b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/city-agent/king-of-contacts.png
// module id = I/wg
// module chunks = 4